import { useEffect } from "react"

/**
 * Set `document.title` while the calling page is mounted and restore the
 * previous title when it unmounts. Client-side route changes don't reset
 * the title on their own. Pass `undefined` to leave the title untouched.
 */
export function useDocumentTitle(title: string | undefined): void {
  useEffect(() => {
    if (!title) return
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
